import { Spinner, SpinnerSize, Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { UsersApi } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { UserDetailPage } from "./UserDetailPage";

export interface IUserItemPageProps {}

export const UserItemPage: React.FunctionComponent<IUserItemPageProps> = (props) => {
  const { id, tab, state } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const api = useApiService(UsersApi);
  const [displayName, loading] = useApiEffect(() => api.getDisplayName(+id), [id]);
  const { t } = useTl();

  const userId = React.useMemo(() => +id, [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Users), route: ERoutes.user },
        { text: +id > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
      actionHistory={+id > 0 && { tlCode: ETLCodes.ActionHistoryUser, name: displayName, id: +id }}
    >
      <ProtectedTabs
        id="TabsUsers"
        onChange={(newTabId) => history.push(`${ERoutes.user}/${userId}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.user} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<UserDetailPage userId={userId} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
